<template>
  <b-container>
    <!-- <h1 class="text-center pt-4 pb-4">Ajout d'un statut</h1>-->
    <b-row v-if="success" class="text-center pt-4">
      <b-col>
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </b-col>
    </b-row>
    <b-form v-else @submit="onSubmit">
      <b-row>
        <b-col sm class="mt-4">
          <b-form-input
            v-model.trim="$v.form.fr.$model"
            :placeholder="$t('label.french')"
          ></b-form-input>
          <div
            class="text-danger"
            v-if="!$v.form.fr.required && $v.form.fr.$dirty"
          >
            {{ $t("info.required") }}
          </div>
          <div
            class="text-danger"
            v-if="!$v.form.fr.maxLength && $v.form.fr.$dirty"
          >
            {{ $t("info.maxLength", [75]) }}
          </div>
        </b-col>
        <b-col sm class="mt-4">
          <b-form-input
            v-model.trim="$v.form.en.$model"
            :placeholder="$t('label.english')"
          ></b-form-input>
          <div
            class="text-danger"
            v-if="!$v.form.en.required && $v.form.en.$dirty"
          >
            {{ $t("info.required") }}
          </div>
          <div
            class="text-danger"
            v-if="!$v.form.en.maxLength && $v.form.en.$dirty"
          >
            {{ $t("info.maxLength", [75]) }}
          </div>
        </b-col>
      </b-row>
      <b-button
        class="mt-4 text-center"
        type="submit"
        variant="success"
        :disabled="disabled"
        >{{ $t("action.submit") }}</b-button
      >
    </b-form>
    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ $t("info.errorgeneric", [error]) }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { required, maxLength } from "vuelidate/lib/validators";
import { globalF } from "../Helpers";

export default {
  mixins: [globalF],
  props: ["values", "tableData", "type"],
  data() {
    return {
      form: {
        fr: this.getData("fr"),
        en: this.getData("en"),
        value: this.getData("value"),
      },
      maxCategoryGraph: 25,
      spinner: false,
      disabled: false,
      success: false,
      error: "",
    };
  },
  validations() {
    return {
      form: {
        fr: { required, maxLength: maxLength(75) },
        en: { required, maxLength: maxLength(75) },
      },
    };
  },
  computed: {
    url: function () {
      return this.getUrl();
    },
  },
  methods: {
    getData: function (field) {
      if (this.values) {
        return this.values[field];
      } else {
        return "";
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.error = "";
        this.spinner = true;
        this.disabled = true;
        this.form.request = this.values
          ? "updateTaskAssignment"
          : "insertTaskAssignment";
        this.form.Id = this.values ? this.values.Id : 0;
        this.form.type = this.type;

        if (this.type === "bucket") {
          this.form.value = this.getBucketValue();
        }
        if (this.type === "label") {
          if (!this.values) {
            this.form.value = this.getLabelValue();
          }
        }

        axios
          .post(this.url, this.form, {
            headers: { "Content-Type": "application/json" },
          })
          .then(() => {
            this.disabled = false;
            this.spinner = false;
            this.success = true;
          })
          .catch(() => {
            this.error = this.$t("info.errorgeneric");
            this.disabled = false;
            this.spinner = false;
          });
      }
    },
    getBucketValue: function () {
      let name = this.form.fr;
      return name.replace(/\W/gi, "").toLowerCase();
    },
    getLabelValue: function () {
      let categoryList = this.tableData;
      for (let i = 1; i < this.maxCategoryGraph; i++) {
        let category = "category" + i;
        let find = categoryList.find((x) => x.value === category);
        if (!find) {
          return category;
        }
      }
    }
  },
};
</script>
